import { CORE_AUTH_SERVICE_CLIENT_ID, CORE_AUTH_SERVICE_CLIENT_SECRET } from 'config'
import { HttpMethod } from 'constants/httpMethod'
import { useCallback, useMemo } from 'react'
import { RequestError, fetchWithTimeout } from 'utils'
import { useServiceCountryUrl } from '../useServiceCountryUrl'

const ApiPathname = {
  TOKEN: '/oauth/token',
} as const

const useFetchCoreAuthToken = () => {
  const { url: baseUrl } = useServiceCountryUrl('core-auth')

  const getToken = useCallback(async (): Promise<string | null> => {
    const url = new URL(ApiPathname.TOKEN, baseUrl).href
    const formData = new FormData()

    formData.append('grant_type', 'client_credentials')
    formData.append('client_id', CORE_AUTH_SERVICE_CLIENT_ID)
    formData.append('client_secret', CORE_AUTH_SERVICE_CLIENT_SECRET)

    const response = await fetchWithTimeout(url, {
      body: formData,
      method: HttpMethod.POST,
    })

    if (!response.ok) {
      throw new RequestError(`Failed to fetch core auth token: ${response.status}`, response.status)
    }

    const data = await response.json()

    return data?.access_token ?? null
  }, [baseUrl])

  return useMemo(() => ({ getToken }), [getToken])
}

export { useFetchCoreAuthToken }
